export default __webpack_public_path__ + "static/media/uponmydeath_12.4bd7205f.png";